import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import ShellHeader from '../components/ShellHeader';
import { auth } from '../firebase';

function LoginPage({ authUser }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authUser) {
      navigate('/admin', { replace: true });
    }
  }, [authUser, navigate]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      navigate('/admin', { replace: true });
    } catch (authError) {
      setError('Invalid login details.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  return (
    <div className="site-shell">
      <ShellHeader authUser={authUser} />
      <main className="auth-wrap">
        <section className="auth-card">
          <h1>Owner Login</h1>
          <p>Sign in with your Firebase Auth owner credentials.</p>

          <form className="upload-form" onSubmit={handleLogin}>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Email"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Password"
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
            <button type="button" onClick={handleForgotPassword}>
              Forgot Password?
            </button>
          </form>

          {error && <p className="status-text">{error}</p>}
        </section>
      </main>
    </div>
  );
}

export default LoginPage;
